import {
  Layout,
  Text,
  Button,
  Modal,
  Padding,
  Icon,
  IconList,
} from "@kidslivesafe/sc-react";

import "./pause-confirmation-modal.css";

import { useAppSelector, useHandlePageNavigate } from "../../../hooks/hooks";
import { selectPauseDetails } from "../../../features/subscriptions/subscriptionSlice";

const PauseConfirmationModal = ({
  showPausedModal,
  setShowPausedModal,
}: {
  showPausedModal: boolean;
  setShowPausedModal: (show: boolean) => void;
}) => {
  const pauseDetails = useAppSelector(selectPauseDetails);
  const pageNavigate = useHandlePageNavigate();

  return (
    <Modal
      open={showPausedModal}
      setOpen={() => {
        setShowPausedModal(false);
      }}
      size="fit-content"
      xClose
      outSideClose
      scrollable={false}
    >
      <Padding space="sm" top="md" bottom="md">
        <Layout
          type="flex"
          flexProps={{
            direction: "column",
            gap: "md",
          }}
        >
          <Layout type="flex" flexProps={{ direction: "column", gap: "sm" }}>
            <Layout type="flex" flexProps={{ gap: "xs", alignItems: "center" }}>
              <Text tag="div" color="success">
                <Icon name={IconList.IconIdProtectCircleCheck} size={24} />
              </Text>
              <Text textAlign="center" tag="h2" fontWeight="semibold">
                Membership Paused
              </Text>
            </Layout>

            <Text size="sm">
              Your membership will pause after your current billing period ends.
            </Text>
          </Layout>

          <Layout type="flex" flexProps={{ direction: "column", gap: "xs" }}>
            <Text size="sm" fontWeight="bold">
              What happens next:
            </Text>
            <Layout
              type="flex"
              flexProps={{ direction: "column", gap: "xxs" }}
              passThroughClassess="pause-confirmation-list"
              tag="ul"
            >
              <Text tag="li" size="sm">
                Keep full access through your current billing period.
              </Text>
              <Text tag="li" size="sm">
                Your membership and billing will then pause for 30 days.
              </Text>
              <Text tag="li" size="sm">
                Reactivate when convenient or auto-restart on{" "}
                <Text tag="span" fontWeight="bold" size="sm">
                  {pauseDetails ? pauseDetails.pauseBillingDate : ""}
                </Text>
                .
              </Text>
            </Layout>
          </Layout>

          <Button
            buttonText="Continue to Dashboard"
            handleClick={() => {
              pageNavigate("/");
              setShowPausedModal(false);
            }}
            color="success"
            fill="fill"
          />
        </Layout>
      </Padding>
    </Modal>
  );
};

export default PauseConfirmationModal;
